var _defs, _circle, _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle2, _circle3, _path13, _path14, _path15, _circle4, _circle5, _path16, _circle6, _circle7, _path17;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExperiment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "experiment_svg__Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 165.27 165.27"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".experiment_svg__cls-1{fill:#eff2f4}.experiment_svg__cls-2{fill:#fcde09}.experiment_svg__cls-3{fill:#fbd201}.experiment_svg__cls-4{fill:#7cc4e1}.experiment_svg__cls-8{fill:#c6d2d3}.experiment_svg__cls-9{fill:#249cd3}.experiment_svg__cls-10{fill:#343a40}.experiment_svg__cls-8{stroke:#000;stroke-miterlimit:10;stroke-width:4px}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "experiment_svg__cls-2",
    cx: 82.63,
    cy: 82.63,
    r: 82.63
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "experiment_svg__cls-8",
    d: "M78.79 27.95c-13.85 0-25.06 11.21-25.06 25.06s11.21 25.06 25.06 25.06 25.06-11.21 25.06-25.06-11.21-25.06-25.06-25.06zM88.55 84.99H69.03c-19.65 0-35.61 15.96-35.61 35.61v14.51c0 2.24 1.71 3.96 3.96 3.96h82.82c2.24 0 3.96-1.71 3.96-3.96V120.6c0-19.65-15.96-35.61-35.61-35.61z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.45,
    y: 131.79,
    width: 136.37,
    height: 20.33,
    rx: 8.89,
    ry: 8.89,
    fill: "#9c9e9f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "experiment_svg__cls-10",
    d: "M77.53 99.87c-.6 0-1.08-.48-1.08-1.08V79.77c0-3.78 3.08-6.86 6.86-6.86h26.61c2.21 0 4 1.79 4 4v1.6c0 .6-.48 1.08-1.08 1.08s-1.08-.48-1.08-1.08v-1.6c0-1.01-.82-1.83-1.83-1.83H83.32c-2.59 0-4.69 2.11-4.69 4.69v19.02c0 .6-.48 1.08-1.08 1.08zM128.88 92.43h-10.21c-.6 0-1.08-.48-1.08-1.08s.48-1.08 1.08-1.08h10.21c.6 0 1.08.48 1.08 1.08s-.48 1.08-1.08 1.08z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "experiment_svg__cls-1",
    d: "M112.97 120.67h-.29c-3.14 0-5.69-2.55-5.69-5.69V82.89h11.67v32.09c0 3.14-2.55 5.69-5.69 5.69z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "experiment_svg__cls-10",
    d: "M106.99 89.16h11.67v4.38h-11.67v-4.38z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "experiment_svg__cls-2",
    d: "M106.99 102.46v12.37c0 3.22 2.61 5.84 5.84 5.84s5.84-2.61 5.84-5.84v-12.37H107z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "experiment_svg__cls-1",
    d: "M119.43 82.89h-13.2c-.79 0-1.42-.64-1.42-1.42v-1.53c0-.79.64-1.42 1.42-1.42h13.2c.79 0 1.42.64 1.42 1.42v1.53c0 .79-.64 1.42-1.42 1.42z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "experiment_svg__cls-2",
    d: "M115.31 134.53s1.46-.88 1.46-3.79c0-2.3-1.86-4.2-3.02-5.15-.53-.44-1.3-.44-1.83 0-1.16.96-3.02 2.85-3.02 5.15 0 2.92 1.46 3.79 1.46 3.79h4.96z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "experiment_svg__cls-3",
    d: "M114.03 134.53s.71-.42.71-1.84c0-.73-.39-1.38-.82-1.87-.58-.66-1.61-.66-2.19 0-.43.49-.82 1.14-.82 1.87 0 1.41.71 1.84.71 1.84h2.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "experiment_svg__cls-10",
    d: "M124.5 141.53h-23.34v-4.16c0-1.57 1.27-2.85 2.85-2.85h17.65c1.57 0 2.85 1.27 2.85 2.85v4.16zM133.25 141.53h-4.38V75.41c0-.79.64-1.42 1.42-1.42h1.53c.79 0 1.42.64 1.42 1.42v66.12zM98.53 144.34v-1.38c0-.79.64-1.42 1.42-1.42h33.3v2.81c0 .79-.64 1.42-1.42 1.42H99.96c-.79 0-1.42-.64-1.42-1.42z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "experiment_svg__cls-1",
    d: "M82.92 104.62v15.32l10.28 20.7a3.54 3.54 0 01-3.17 5.12h-25a3.54 3.54 0 01-3.17-5.12l10.28-20.7v-15.32h10.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "experiment_svg__cls-9",
    d: "M90.03 145.76a3.54 3.54 0 003.17-5.12l-7.46-15.01c-2.44.01-5.23.69-8.22 2.48-3.53 2.12-7.23 2.2-10.27 1.63l-5.41 10.9a3.54 3.54 0 003.17 5.12h25z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "experiment_svg__cls-1",
    d: "M84.13 104.62h-13.2c-.79 0-1.42-.64-1.42-1.42v-2.99c0-.79.64-1.42 1.42-1.42h13.2c.79 0 1.42.64 1.42 1.42v2.99c0 .79-.64 1.42-1.42 1.42z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "experiment_svg__cls-4",
    cx: 80.74,
    cy: 134.09,
    r: 2.19
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "experiment_svg__cls-4",
    cx: 71.4,
    cy: 139.78,
    r: 2.19
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "experiment_svg__cls-3",
    d: "M120.71 128.17h-.73c-.6 0-1.08-.48-1.08-1.08s.48-1.08 1.08-1.08h.73c.6 0 1.08.48 1.08 1.08s-.48 1.08-1.08 1.08zM117.79 125.98c-.6 0-1.08-.48-1.08-1.08v-.73c0-.6.48-1.08 1.08-1.08s1.08.48 1.08 1.08v.73c0 .6-.48 1.08-1.08 1.08zM105.68 128.17h-.73c-.6 0-1.08-.48-1.08-1.08s.48-1.08 1.08-1.08h.73c.6 0 1.08.48 1.08 1.08s-.48 1.08-1.08 1.08zM107.87 125.98c-.6 0-1.08-.48-1.08-1.08v-.73c0-.6.48-1.08 1.08-1.08s1.08.48 1.08 1.08v.73c0 .6-.48 1.08-1.08 1.08z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "experiment_svg__cls-10",
    d: "M29.62 54.35l3.2-4.11-.2 5.2 5.1-1.09-3.5 3.86 4.61 2.44-5.16.71 1.96 4.82-4.41-2.77-1.6 4.96-1.6-4.96-4.41 2.77 1.96-4.82-5.16-.71 4.61-2.44-3.5-3.86 5.09 1.09-.19-5.2 3.2 4.11z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "experiment_svg__cls-9",
    d: "M46.5 88.06l4.95-6.36-.3 8.05 7.87-1.69-5.4 5.97 7.12 3.77-7.98 1.1 3.04 7.46-6.83-4.28-2.47 7.67-2.47-7.67-6.82 4.28 3.03-7.46-7.98-1.1 7.12-3.77-5.4-5.97 7.87 1.69-.29-8.05 4.94 6.36z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "experiment_svg__cls-9",
    cx: 101.19,
    cy: 28.51,
    r: 3.24
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.06,
    cy: 70.74,
    r: 2.03,
    fill: "#c6d2d3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M142.19 45.13a.851.851 0 01-.67-.78c-.34-6.02-5.5-10.63-11.52-10.29-4.13.23-7.78 2.78-9.42 6.58a.845.845 0 01-1.21.39A7.548 7.548 0 00109 43.58c-.6.98-.96 2.09-1.06 3.23-.02.23-.14.45-.32.59-.18.14-.42.2-.65.17a5.048 5.048 0 00-5.76 4.21 5.048 5.048 0 004.21 5.76c.79.12 1.6.06 2.37-.2.23-.07.47-.05.68.07.21.12.35.32.4.56a5.88 5.88 0 006.95 4.55 6.06 6.06 0 001.85-.73c.38-.23.87-.13 1.13.24 2.9 4.2 8.66 5.25 12.86 2.34a9.269 9.269 0 003.62-5.02c.13-.45.6-.7 1.04-.57.08.02.16.06.23.1 3.49 2.3 8.19 1.33 10.48-2.16 2.3-3.49 1.33-8.19-2.16-10.48a7.54 7.54 0 00-2.69-1.1zM101.93 76.75c.17.05.29.2.29.37-.01 2.76 2.21 5 4.97 5.01 1.89 0 3.62-1.05 4.48-2.74.1-.19.33-.26.52-.17.02 0 .03.02.04.03a3.45 3.45 0 004.8-.88c.3-.43.5-.93.57-1.45.02-.11.07-.2.16-.26s.2-.08.3-.06c1.24.27 2.47-.52 2.75-1.76.27-1.24-.52-2.47-1.76-2.75-.36-.08-.73-.07-1.08.02-.11.03-.22 0-.31-.05a.415.415 0 01-.17-.26 2.694 2.694 0 00-3.92-1.99c-.18.09-.4.03-.51-.14-1.21-2-3.81-2.63-5.8-1.42-.83.5-1.46 1.28-1.79 2.19-.07.2-.29.3-.49.23a.313.313 0 01-.1-.05 3.451 3.451 0 00-4.84.7c-1.15 1.53-.83 3.7.7 4.84.36.27.76.46 1.19.58z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "experiment_svg__cls-10",
    cx: 70.03,
    cy: 47.95,
    r: 3.02
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "experiment_svg__cls-10",
    cx: 87.5,
    cy: 47.95,
    r: 3.02
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M68.65 59.17c0 10.89 20.22 10.89 20.22 0",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    strokeLinecap: "round",
    fill: "#c6d2d3"
  })));
}

export default SvgExperiment;